var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary mr-1",attrs:{"type":"button","disabled":!_vm.anyFileSelected},on:{"click":_vm.downloadFiles}},[_c('i',{staticClass:"far fa-arrow-from-top"}),_vm._v(" "+_vm._s(_vm.$t("buttons.download"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }